export default __webpack_public_path__ + "static/media/25_cut.1f5ad8e4.jpg";